import { cn } from "@/libs/cn";

const gridCols = "md:grid-cols-[3fr_5fr_4fr_4fr_2.5fr]";
const gridGap = "md:gap-4";
export const gridLayout = cn("flex flex-col gap-2 md:grid md:items-center", gridCols, gridGap, "px-4 md:px-6 py-3 md:py-2");

export const SKELETON_COLUMNS = 5;

const ImportHistoryListHeader = () => {
  const headerStyle = "text-sm text-ui-navy-dark font-semibold text-gray-500 truncate";

  return (
    <div className={cn("hidden md:grid md:items-center", gridCols, gridGap, "bg-white border-b border-gray-100 px-6 py-4")}>
      <span className={headerStyle}>Data/Hora</span>
      <span className={headerStyle}>Arquivo</span>
      <span className={headerStyle}>Responsável</span>
      <span className={headerStyle}>Status</span>
      <span className={headerStyle}>Registros processados</span>
    </div>
  );
};

export default ImportHistoryListHeader;
